<template>
    <ModalContent 
        ref="redact-confirmation" 
        name="redact-confirmation"
        :title="$t('fields.provide_redact_reason')" 
        width="50%" :maxWidth="480" 
        @cancel="handleCloseModal()" 
        @submit="redactFields()" 
        :submitButtonText="$t('actions.submit')"
        :disabled="!redactData.reason || !redactData.confirm">
        <template #content>
            <div class="container flex w-full flex-grow items-center justify-center max-w-full overflow-y-hidden scroll-bar">
                <div class="flex flex-col w-full">
                    <label class="text-gray-500 tracking-wide text-sm">
                        {{ $t('fields.redact_reason') }}
                        <span class="text-red-600" > * </span>
                    </label>
                    <neo-input :changeCase="true" style="border: 1px solid #e8e8e8" :shadow="false" 
                        class="rounded-lg h-10 mt-1" hideSearchIcon
                        borderColor="#e8e8e8" bg="#fff" margin="0.25rem 0 0 0" :style="{width: '100%'}" 
                        :placeholder="$t('fields.redact_reason')" 
                        v-model="redactData.reason" />
                    <div class="flex items-start mt-2">
                        <input type="checkbox" v-model="redactData.confirm"
                            class="ml-0 text-gray-700 border rounded mr-2 mt-1" />
                        <label class="cursor-pointer" for="peps">
                            {{ $t('fields.redact_dialogue_submission_value') }}
                        </label>
                    </div>
                </div>
            </div>
        </template>
    </ModalContent>
</template>

<script>
import ModalContent from "@shared/modal-content"
import { mapGetters, mapActions } from "vuex";
import Input from "@shared/saas-components/input/index";

export default {
    name: "app-header",
    components: {
        ModalContent,
        "neo-input": Input,
    },
    props: {
    },
    data() {
        return {
          redactData: {
            reason: "",
            confirm: false
          },
        };  
    },
    computed: {
        ...mapGetters([
        ]),
    },
    async mounted() {
    },
    watch: {
    },
    methods: {
        ...mapActions(["fetchCaseData", "fetchCaseStatusLists", "setTenantDetails", "setpoweredLogo"]),

        redactFields() {
            this.$emit('redactFields', this.redactData)
        },

        handleCloseModal() {
            this.$refs['redact-confirmation'].hideModal();
        }
    },
    created() {
    }
};
</script>